'use client';
import { motion } from 'framer-motion';

const Title = ({ title = 'Default Title', className = '' }) => {
  return (
    <motion.h1
      className={`text-center text-2xl lg:text-4xl text-white font-bold ${className}`}
      initial={{ opacity: 0, y: -20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-20px" }} 
      transition={{ 
        duration: 0.5,
        ease: "easeOut" 
      }}
    >
      {title}
    </motion.h1>
  );
};

export default Title;